import { Typography } from "@mui/material";
import React from "react";
import { FooterButton } from "../../ServiceFunctionsModal.styles";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../ServiceFunctionsModal.types";
import { ContentTypography } from "../ServiceModal.styles";
import { deletePostComment } from "@infrastructure/Services/PostCommentsService";
import {
    RESPONSE_CODE_RESOURCE_NOT_FOUND,
    RESPONSE_CODE_RESOURCE_SUSPENDED,
} from "@infrastructure/BackendClientCodes";
import {
    RESET_API_CACHE_REASONS,
    resetIgnoreApiCacheTime,
} from "@infrastructure/Services/ApiUtility";

export default function DeletingCommentConfirmation(
    onSelectedCommentSuccessDeleteHandler,
    setModalCurrentAction,
    selectedComment,
) {
    function onSelectedCommentDeleteHandler() {
        deletePostComment(selectedComment.commentContent.id)
            .then((response) => {
                resetIgnoreApiCacheTime(RESET_API_CACHE_REASONS.COMMENT_DELETE);
                onSelectedCommentSuccessDeleteHandler(response);
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.DELETED_COMMENT,
                );
            })
            .catch((reason) => {
                if (
                    reason.response?.status ===
                        RESPONSE_CODE_RESOURCE_SUSPENDED ||
                    reason.response?.status === RESPONSE_CODE_RESOURCE_NOT_FOUND
                ) {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.REPORTED_CONTENT_RESTRICTED,
                    );
                } else {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_DELETING_COMMENT,
                    );
                }
            });
    }

    const modalTitle = <Typography>Beitrag wirklich löschen?</Typography>;
    const modalContent = (
        <ContentTypography>
            Der Beitrag wird endgültig gelöscht und kann nicht wieder
            hergestellt werden.
        </ContentTypography>
    );
    const modalActions = (
        <FooterButton variant={"text"} onClick={onSelectedCommentDeleteHandler}>
            Beitrag löschen
        </FooterButton>
    );
    return { modalTitle, modalContent, modalActions };
}
